import {
  FieldValues,
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import Select from "../../../../../shared/components/UI/Select";
import ButtonSave from "../components/ButtonSave";
import MultiSelect from "../../../../../shared/components/UI/MultiSelect";
import { useEffect, useState } from "react";
import axios from "axios";
import ErrorWrap from "../components/ErrorWrap";

interface Props {
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  hasUnsavedChanges: boolean;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<FieldValues>;
  teamList: string[];
}

interface Camo {
  name: string;
  image: string;
}

interface CamoOption {
  id: string;
  name: string;
  image: string;
}

export default function ShowcaseTab({
  watch,
  hasUnsavedChanges,
  register,
  setValue,
  getValues,
  teamList,
}: Props) {
  const [camoOptions, setCamoOptions] = useState<CamoOption[]>([]);

  useEffect(() => {
    async function fetchCamouflages() {
      try {
        const response = await axios.get<Camo[]>("/info/camouflages/");
        const opts: CamoOption[] = response.data.map((item, idx) => ({
          id: String(idx),
          name: item.name,
          image: item.image,
        }));
        setCamoOptions(opts);
      } catch (err) {
        console.error(err);
      }
    }
    fetchCamouflages();
  }, []);
  const mainSpecList = watch("specList") ? [watch("specList")] : [];
  const mainSpec = watch("main_spec");
  const team = watch("team_slug");
  const armoryList = watch("armoryList");
  const selectedArmory = watch("user_armory");
  return (
    <>
      <div className="cabinet_profileeditmodal-right-content">
        <div className="cabinet_profileeditmodal-right-content-text">
          <div className="cabinet_profileeditmodal-right-content-text-title">
            Витрина
          </div>
          <div className="cabinet_profileeditmodal-right-content-text-description">
            Выберите то, чем хотите поделиться
          </div>
        </div>
        <Select
          options={mainSpecList}
          value={mainSpec}
          isChangeable
          placeholder="Специализация"
          setValue={setValue}
          formName="main_spec_name_select"
          classes={{
            select_wrapper: "cabinet_profileeditmodal-right-content-region",
            select_option:
              "cabinet_profileeditmodal-right-content-region-option",
            select_placeholder:
              "cabinet_profileeditmodal-right-content-region-placeholder",
          }}
        />
        <Select
          options={teamList || []}
          value={team}
          isChangeable
          placeholder="Команда"
          setValue={setValue}
          formName="team_slug"
          classes={{
            select_wrapper: "cabinet_profileeditmodal-right-content-region",
            select_option:
              "cabinet_profileeditmodal-right-content-region-option",
            select_placeholder:
              "cabinet_profileeditmodal-right-content-region-placeholder",
          }}
        />
        <Select
          options={armoryList || []}
          value={selectedArmory}
          isChangeable
          placeholder="Привод"
          setValue={setValue}
          formName="selectedArmory"
          classes={{
            select_wrapper: "cabinet_profileeditmodal-right-content-region",
            select_option:
              "cabinet_profileeditmodal-right-content-region-option",
            select_placeholder:
              "cabinet_profileeditmodal-right-content-region-placeholder",
          }}
        />
        <MultiSelect
          className="cabinet_profileeditmodal-multiselect"
          title="Камуфляж"
          setValue={setValue}
          name="camouflagesList"
          getValues={getValues}
          watch={watch}
          hasSearch={false}
          items={camoOptions as unknown as never[]}
          classes={{ image: "ada" }}
        ></MultiSelect>
        <ErrorWrap>
          <MultiSelect
            className="cabinet_profileeditmodal-multiselect"
            title="Достижения"
            setValue={setValue}
            name="asd"
            getValues={getValues}
            watch={watch}
            hasSearch={false}
          ></MultiSelect>
        </ErrorWrap>
      </div>
      <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
    </>
  );
}
